/* hs-eslint ignored failing-rules */

import * as ActionTypes from './ActionTypes';
import SiteSettingsApi from '../api/SiteSettings';
export const getSiteSettings = () => dispatch => {
  dispatch({
    type: ActionTypes.FETCH_SITE_SETTINGS_PENDING
  });
  return SiteSettingsApi.fetch().then(payload => {
    dispatch({
      type: ActionTypes.FETCH_SITE_SETTINGS_SUCCESS,
      payload
    });
  }).catch(error => {
    console.warn('Failed to fetch site settings', error);
    dispatch({
      type: ActionTypes.FETCH_SITE_SETTINGS_ERROR,
      error: true,
      payload: error
    });
  });
};